import { BaseModel } from "sjs-base-model";
import SezioneModel from "./SezioneModel";

export default class ContenutoModel extends BaseModel {
    public readonly idContenuto: number = 0;
    public readonly titolo: string = "";
    public readonly codiceTipoContenuto: string = "";
    public readonly sezioni: SezioneModel[] = [];

    constructor(data: Partial<ContenutoModel>) {
        super();

        this.update(data);
    }
}
